/**
 * Converts the given decimal amount into a currency string.
 * @param {float} The decimal amount, e.g. 241.4
 * @returns A string representing the decimal amount in currency format, e.g. $241.40.
 */
export const convertToCurrencyString = (amount, sigFigs = 2) => {
  if (typeof amount !== 'number') return ''; // Filter out null, undefined, strings and objects

  const amountTo2SigFigs = amount.toFixed(sigFigs);
  return `$${amountTo2SigFigs}`;
};
